import { Button } from "@/components/ui/button";
import ApiKeyStore from "@/stores/ApiKeyStore";
import { useTranslation } from "react-i18next";
import { useApiKeyInput } from "@/hooks/useApiKeyInput";

export function SaveApiKeyButton() {
    const { t } = useTranslation();
    const hasChanges = ApiKeyStore(state => state.hasChanges);
    const { isLoading, handleSaveApiKey } = useApiKeyInput();

    return (
        <Button onClick={handleSaveApiKey} className="w-full p-0 h-9" disabled={isLoading || !hasChanges}>
            {t("common.save")}
        </Button>
    );
}

